import * as api from '../api';
import {
  FETCH_BOOKED_SEATS_REQUEST,
  FETCH_BOOKED_SEATS_SUCCESS,
  FETCH_BOOKED_SEATS_FAILURE,
  RESET_SEATS_REQUEST,
  RESET_SEATS_SUCCESS,
  RESET_SEATS_FAILURE,
} from './constants';

export const getBookedSeats = (tripDate, tripNumber) => async (dispatch) => {
  dispatch({ type: FETCH_BOOKED_SEATS_REQUEST });
  try {
    const { data } = await api.fetchBookedSeats(tripDate, tripNumber);
    console.log('getBookedSeats API response:', data); // Debug log
    dispatch({ type: FETCH_BOOKED_SEATS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_BOOKED_SEATS_FAILURE, payload: error.message });
  }
};

export const resetSeatsAction = (tripDate, currentTripNumber) => async (dispatch) => {
  dispatch({ type: RESET_SEATS_REQUEST });
  try {
    const res = await api.resetSeatsAndIncrement(tripDate);
    dispatch({ type: RESET_SEATS_SUCCESS });
    dispatch(getBookedSeats(tripDate, res.data.tripNumber));
    return res.data.tripNumber;
  } catch (error) {
    dispatch({ type: RESET_SEATS_FAILURE, payload: error.message });
  }
}; 